import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

//配置路由
const routes = [
  { path: '/', redirect: 'login' },
  {
    path: '/login',
    name: 'loginComponents',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/password',
    name: 'Password',
    component: () => import('@/views/login/password.vue')
  },

  {
    path: '/home',
    component: () =>
      import('@/views/home/home.vue'),
    children: [
      {
        path: '/',
        component: () => import('@/views/firstpage/firstpage.vue'),
      },
      {
        path: '/jobs',
        component: () => import('@/views/jobs/index.vue'),
      },
      {
        path: '/messages',
        component: () => import('@/views/messages/messages.vue'),
      },
      {
        path: '/talent',
        component: () => import('@/views/talent/talent.vue'),
      },
      {
        path: '/serverList',
        component: () => import('@/views/serverList/serverList.vue'),
      },
      {
        path: '/subsidiary',
        component: () => import('@/views/subsidiary/subsidiary.vue'),
      },
      {
        path: '/management',
        component: () => import('@/views/management/index.vue'),
      },
      {
        path: '/resumelist',
        component: () => import('@/views/resumelist/index.vue'),
      },
      {
        path: '/company',
        component: () => import('@/views/company/index.vue'),
      },
      {
        path: '/setting',
        component: () => import('@/views/setting/setting.vue'),
      },
      {
        path: '/user',
        component: () => import('@/views/user/index.vue'),
      },
      {
        path: '/address',
        component: () => import('@/views/address/index.vue'),
      },
      {
        path: '/enroll',
        component: () => import('@/views/enroll/index.vue'),
      }
    ]
  }
];

//实例化VueRouter
const router = new VueRouter({
  routes
});


//将router暴露出去
export default router;